import { render, staticRenderFns } from "./2FASetupPrompt.vue?vue&type=template&id=4847ad31&"
import script from "./2FASetupPrompt.vue?vue&type=script&lang=js&"
export * from "./2FASetupPrompt.vue?vue&type=script&lang=js&"
import style0 from "./2FASetupPrompt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports